import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';
  angular.module('app').service('TaxService', TaxService);

  TaxService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'moment',
    'SessionService',
    'WindowModalService',
  ];

  function TaxService(
    RestResource,
    config,
    UtilService,
    $translate,
    $filter,
    moment,
    SessionService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'taxes';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getTaxes: getTaxes,
      saveTax: saveTax,
      openTaxDetailModal: openTaxDetailModal,
      changeTaxStatus: changeTaxStatus,
      deleteTax: deleteTax,
      setTaxes: setTaxes,
      getTodaysRate: getTodaysRate,
      setAssociatedTaxes: setAssociatedTaxes,
      validateAssociatedTaxesApplied: validateAssociatedTaxesApplied,
      applyProductAssociatedTaxes: applyProductAssociatedTaxes,
      setProductTaxes: setProductTaxes,
      setProductTaxesAmounts: setProductTaxesAmounts,
      getProductTaxesTotalPercentage: getProductTaxesTotalPercentage,
      getProductTaxesTotalAmount: getProductTaxesTotalAmount,
      getProductTaxesTotalExonerationPercentage: getProductTaxesTotalExonerationPercentage,
      getProductTaxesTotalExonerationAmount: getProductTaxesTotalExonerationAmount,
      setBaseCostPrice: setBaseCostPrice,
      // setProductTotalTaxAmount:         setProductTotalTaxAmount
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getTaxes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function saveTax(tax, language) {
      var itemAddedMsg = $translate('TAX_ADDED');
      var itemModifiedMsg = $translate('TAX_MODIFIED');
      var method;
      var url = apiUrl;

      if (!tax.id) {
        // create
        method = 'post';
        tax.company_id = SessionService.getSelectedAccountCompany().id;
      } else {
        method = 'put';
        url = url + '/' + tax.id;
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = tax.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { tax: tax, lang: lang }, success, failure);
    }

    function openTaxDetailModal(tax, mode, taxTypes, successCallback) {
      var templateUrl = './app/ajs/taxes/modals/tax-detail-modal.html';

      var originalItem = angular.copy(tax);

      var modalParams = {
        title: 'TAX_DETAILS',
        item: originalItem,
        mode: mode,
        preventModalClose: true,
        additionalParams: {
          taxTypes: taxTypes,
        },
        // additionalLanguages: additionalLanguages
      };

      // if (!documentType.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      var confirmCallback = function (response) {
        if (tax.id) {
          // Edit
          tax.name = response.name;
          tax.tax_type = response.tax_type;
          tax.code = response.code;
          tax.computation_type = response.computation_type;
          tax.scope_type = response.scope_type;
          tax.is_default = response.is_default;
          tax.tax_rates = response.tax_rates;
          tax.currency_id = response.currency_id;

          utils.itemListChanged(response.id); // return;
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function changeTaxStatus(tax, successCallback) {
      let url = apiUrl + '/' + tax.id + '?set_status=true';

      let newStatus = tax.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          let params = {
            title: 'DEACTIVATE_TAX',
            body: 'DEACTIVATE_TAX_WARNING',
            requireConfirmation: true,
            successMsg: 'TAX_DEACTIVATED',
          };

          if (tax.used_in_transactions) {
            params.body += 'THIS_ACTION_WILL_DEACTIVATE_PRODUCTS_RELATEDS';
          }

          utils.changeItemStatus(url, tax, params, successCallback);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteTax(tax, successCallback) {
      let url = apiUrl + '/' + tax.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_TAX',
            body: 'DELETE_CUSTOM_TAXES_WARNING',
            mode: 'danger',
            requireConfirmation: true,
            successMsg: 'TAX_DELETED',
          };

          if (tax.used_in_transactions) {
            params.body += 'THIS_CONFIGURATION_HAS_BEEN_ADDED_TO_PRODUCTS';
          }

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function setTaxes(taxes, taxTypes) {
      // tax_type is when atv enable
      var taxeList = [];

      taxes.forEach(function (tax) {
        if (tax.tax_type) {
          tax.taxType = utils.findItemInArray(taxTypes, 'code', tax.tax_type);
        }

        if (tax.tax_rates) {
          //  || source
          taxeList.push(tax);
        }
      });

      taxeList = getTodaysRate(taxeList);

      // taxeList.sort((a, b) =>
      // a.currentDate && b.currentDate && a.currentDate.value - b.currentDate.value);

      return taxeList;
    }

    function getTodaysRate(taxes) {
      let today = moment(); // includes current time
      // let today = moment().startOf('day');

      taxes.forEach(function (tax) {
        tax.todaysRate = null;

        // console.log(tax.tax_rates);

        if (tax.tax_rates) {
          for (var i = 0; i < tax.tax_rates.length; i++) {
            var tax_rate = tax.tax_rates[i];

            // console.log(moment(tax_rate.from));
            // console.log(today);

            if (today.isBetween(moment(tax_rate.from), moment(tax_rate.to).add(1, 'days'))) {
              tax.todaysRate = tax_rate;
              break;
            }
          }
        }
      });

      return taxes;
    }

    // Check the tax if found in the (Product category / Product) associated rates
    function setAssociatedTaxes(taxes, associatedTaxes, taxTypes) {
      // productExonerations
      var associatedTax;
      var taxRate;

      let today = moment(); // includes current time
      // let today = moment().startOf('day');

      // console.log(taxes);
      // console.log(associatedTaxes);
      // console.log(taxTypes);

      // Purchase taxes
      if (taxes.purchases) {
        taxes.purchases.forEach(function (purchaseTax) {
          if (purchaseTax.tax_type && taxTypes) {
            // purchaseTax.taxTypeName = utils.findItemInArray(
            //     taxTypes, 'code', purchaseTax.tax_type
            // )['name'];
            purchaseTax.taxTypeName = taxTypes.find(
              (taxType) => taxType.code === purchaseTax.tax_type
            )['name'];
          }

          if (purchaseTax.tax_rates) {
            for (var j = 0; j < purchaseTax.tax_rates.length; j++) {
              taxRate = purchaseTax.tax_rates[j];

              if (today.isBetween(moment(taxRate.from), moment(taxRate.to).add(1, 'days'))) {
                purchaseTax.currentDate = taxRate;
                break;
              }
            }
          }

          purchaseTax.checked = false;
          if (associatedTaxes && associatedTaxes.length > 0) {
            for (var i = 0; i < associatedTaxes.length; i++) {
              associatedTax = associatedTaxes[i];

              if (associatedTax.id === purchaseTax.id) {
                purchaseTax.checked = true;

                break;
              }
            }
          }
        });

        taxes.purchases.sort(
          (a, b) => a.currentDate && b.currentDate && a.currentDate.value - b.currentDate.value
        );
      }

      // Sale taxes
      if (taxes.sales) {
        taxes.sales.forEach(function (saleTax) {
          if (saleTax.tax_type && taxTypes) {
            // saleTax.taxTypeName = utils.findItemInArray(
            //     taxTypes, 'code', saleTax.tax_type
            // )['name'];
            saleTax.taxTypeName = taxTypes.find((taxType) => taxType.code === saleTax.tax_type)[
              'name'
            ];
          }

          if (saleTax.tax_rates) {
            for (var j = 0; j < saleTax.tax_rates.length; j++) {
              taxRate = saleTax.tax_rates[j];

              if (today.isBetween(moment(taxRate.from), moment(taxRate.to).add(1, 'days'))) {
                saleTax.currentDate = taxRate;
                break;
              }
            }
          }

          saleTax.checked = false;
          if (associatedTaxes && associatedTaxes.length > 0) {
            for (var i = 0; i < associatedTaxes.length; i++) {
              associatedTax = associatedTaxes[i];

              if (associatedTax.id === saleTax.id) {
                saleTax.checked = true;

                break;
              }
            }
          }

          // if (productExonerations) {
          //     saleTax.exoneration = productExonerations.find((exoneration) => exoneration.tax_id === saleTax.id);
          // }
        });

        taxes.sales.sort(
          (a, b) => a.currentDate && b.currentDate && a.currentDate.value - b.currentDate.value
        );
      }

      return taxes;
    }

    function validateAssociatedTaxesApplied(taxes) {
      let validPurchaseTaxes = false;
      let purchaseTax;

      for (let i = 0; i < taxes.purchases.length; i++) {
        purchaseTax = taxes.purchases[i];

        if (purchaseTax.checked) {
          validPurchaseTaxes = true;
          break;
        }
      }

      let validSaleTaxes = false;
      let saleTax;

      for (let i = 0; i < taxes.sales.length; i++) {
        saleTax = taxes.sales[i];

        if (saleTax.checked) {
          validSaleTaxes = true;
          break;
        }
      }

      if (validPurchaseTaxes && validSaleTaxes) {
        return false;
      }

      return true;
    }

    function applyProductAssociatedTaxes(product, productType, apply_taxes) {
      let url =
        environment.apiEndpoint + productType + 's/' + product.id + '/apply_associated_taxes';

      if (apply_taxes) {
        url += '?apply_taxes=true';
      }

      return RestResource.request(
        'put',
        url,
        { [productType]: product },
        function (response) {
          if (apply_taxes) {
            utils._successMsg($translate('CUSTOM_CONFIGURATION_MODIFIED')); // TAXES_APPLIED
          }

          return response.data;
        },
        function (response) {
          utils._errorMsg(response.data.errors);
          return false;
        }
      );
    }

    function setBaseCostPrice(rate, price_list, taxes) {
      // console.log(price_list);
      if (!price_list.taxes_included || !taxes) {
        return rate;
      }

      let totalTaxesValue = taxes.reduce((total, tax) => total + tax.value, 0);
      let totalTaxesExonerationsPercentage = taxes.reduce(
        (total, tax) => total + (tax.exoneration ? tax.exoneration.percentage : 0),
        0
      );
      let totalNetTaxesPercentage = totalTaxesValue - totalTaxesExonerationsPercentage;

      // console.log(taxes);
      // console.log('totalTaxesValue: ', totalTaxesValue);
      // console.log('totalTaxesExonerationsPercentage: ', totalTaxesExonerationsPercentage);
      // console.log('totalNetTaxesPercentage: ', totalNetTaxesPercentage);

      return rate / (totalNetTaxesPercentage / 100 + 1); // totalTaxesValue

      // let totalTaxesExonerationsAmount = taxes.reduce((total, tax) =>
      //     total + (tax.computation_type === 'percentage' && tax.exoneration ?
      //         rate * (tax.exoneration.percentage / 100) : 0), 0
      // );

      // return utils.roundNum(day['item_'+ type] / ((totalTaxesValue / 100) + 1));
    }

    function setProductTaxes(product, documentDate) {
      // Get taxes where today is between from-to
      let getDocumentDateTax = function (taxes, documentDate) {
        if (!taxes) {
          return [];
        }

        return taxes
          .filter((tax) =>
            tax.tax_rates.find((t_r) => documentDate.isBetween(t_r.from, t_r.to, null, '[]'))
          )
          .map((tax) => {
            let obj = {
              // id:               tax.id,
              computation_type: tax.computation_type,
              scope_type: tax.scope_type,
              value: tax.tax_rates.find((t_r) =>
                documentDate.isBetween(t_r.from, t_r.to, null, '[]')
              ).value,
              tax_id: tax.id,
              name: tax.name,
              tax_rate_code: tax.tax_rate_code,
              tax_type: tax.tax_type,
              exoneration: null,
            };

            if (product.exonerations) {
              let exoneration = product.exonerations.find(
                (exoneration) => exoneration.tax_id === tax.id
              );

              if (exoneration) {
                obj.exoneration = {
                  document_number: exoneration.document_number,
                  institution_name: exoneration.institution_name,
                  date: exoneration.date,
                  percentage: exoneration.percentage,
                  exoneration_type_code: exoneration.exoneration_type_code,
                };
              }
            }

            return obj;
          });
      };

      let setTaxes = function (associatedTaxes) {
        // Purchase taxes
        let purchaseTaxes = associatedTaxes.filter(
          (associated_tax) =>
            associated_tax.scope_type === 'purchases' &&
            associated_tax.tax_rates &&
            associated_tax.tax_rates.length > 0
        );

        // Sale taxes
        let saleTaxes = associatedTaxes.filter(
          (associated_tax) =>
            associated_tax.scope_type === 'sales' &&
            associated_tax.tax_rates &&
            associated_tax.tax_rates.length > 0
        );

        return {
          purchaseTaxes: getDocumentDateTax(purchaseTaxes, documentDate),
          saleTaxes: getDocumentDateTax(saleTaxes, documentDate),
        };
      };

      // Product has associated taxes
      if (
        product.custom_tax_configuration &&
        product.associated_taxes &&
        product.associated_taxes.length > 0
      ) {
        return setTaxes(product.associated_taxes);
      }
      // Product category associated taxes
      else if (
        product.product_category &&
        product.product_category.associated_taxes &&
        product.product_category.associated_taxes.length > 0
      ) {
        return setTaxes(product.product_category.associated_taxes);
      } else {
        // Taxes
        return {
          purchaseTaxes: [], // false
          saleTaxes: [], // false
        };

        // return {
        //     purchaseTaxes: [{ value: 0 }],
        //     saleTaxes:     [{ value: 0 }]
        // };

        // return setTaxes(taxes); // TODO: why are we calculating all taxes ?
      }
    }

    // To include the amount to tax
    function setProductTaxesAmounts(subtotal, taxes) {
      if (!taxes) return [];
      if (taxes.length === 0) return taxes;

      subtotal = subtotal || 0;

      return taxes.map((tax) => {
        tax.amount =
          tax.computation_type === 'percentage' ? subtotal * (tax.value / 100) : tax.value;

        // console.log(tax.computation_type);
        // console.log(subtotal);
        // console.log(tax.value);
        // console.log(tax.amount);

        // To include the amount to tax exoneration
        if (tax.computation_type === 'percentage' && tax.exoneration) {
          //  && !tax.exoneration.amount
          tax.exoneration.amount = subtotal * (tax.exoneration.percentage / 100);
        }

        return tax;
      });
    }

    function getProductTaxesTotalPercentage(taxes) {
      if (!taxes || taxes.length === 0) return 0;

      return taxes.reduce((total, tax) => total + tax.value, 0);

      // return vm.UtilService.currencyFormat(taxes.reduce((total, tax) => total + tax.value, 0), vm.decimalPlaces);
    }

    function getProductTaxesTotalAmount(taxes) {
      if (!taxes || taxes.length === 0) return 0;

      return taxes.reduce((total, tax) => total + tax.amount, 0);
      // return utils.roundNum(taxes.reduce((total, tax) => total + tax.amount, 0));
    }

    function getProductTaxesTotalExonerationPercentage(taxes) {
      if (!taxes || taxes.length === 0) return 0;

      return taxes.reduce(
        (total, tax) => total + (tax.exoneration ? tax.exoneration.percentage : 0),
        0
      );
    }

    function getProductTaxesTotalExonerationAmount(taxes) {
      if (!taxes || taxes.length === 0) return 0;

      return taxes.reduce(
        (total, tax) => total + (tax.exoneration ? tax.exoneration.amount : 0),
        0
      );
      // return utils.roundNum(taxes.reduce((total, tax) => total + (tax.exoneration ? tax.exoneration.amount : 0), 0));
    }
  }
})();
